import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import CommentListing from "components/CommentListing/CommentListing";
// import Pagination from "shared/Pagination/Pagination";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
// import WidgetTags from "./WidgetTags";
// import WidgetCategories from "./WidgetCategories";
// import WidgetPosts from "./WidgetPosts";
// import Card3 from "./Card3";

// import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
// import Editor from "./Editor";
import { Link, useNavigate, useParams } from "react-router-dom";
//import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
import PostCardMeta from "./PostCardMeta";

import Input from "shared/Input/Input";

import ButtonCircle from "shared/Button/ButtonCircle";
import { ArrowRightIcon, ArrowSmallLeftIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";

import SigninForm from "components_custom/SigninForm/SigninForm";

import GuestAvatar from "assets/images/guest.png";
import ReservationCard from "./ProductCard";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import CommunityComments from "./CommunityComments";

//import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
  posts?: PostDataType[];
  className?: string;
  postCardName?: "card3";
}


const CommunityView = ({
  posts = postsDemo,
  postCardName = "card3",
  className = "",
}: any) => {

	const { id } = useParams();

	const {
		toast,
		modal,
	} = useContext (UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();

	const [info, setInfo] = useState <any> ({});
	const [contents, setContents] = useState <any> ("");
	

	


	useEffect (() => {
		
		(async () => {
			
			const res: any = await requestAPI('GET', `v1/community/${id}`, null);
			//const res2: any = await requestAPI('GET', `v1/comment/community/${id}`, null);

			console.log('dis dis dis', res.data.info)
			const _info = res.data.info;
			const user_profileUrl = _info.user_profileUrl;

			console.log(">> _info", _info.user_id);
			// console.log(">> initData", initData.userInfo._id);

			res.data.info["profileUrl"] = (user_profileUrl === null)
			? `${process.env.REACT_APP_SERVER_FILE}/avatar/guest.png`
			: `${process.env.REACT_APP_SERVER_FILE}/avatar/${user_profileUrl}`; 
			
			res.data.info["coverUrl"] = (_info.product_cover === null)
			? null 
			: `${process.env.REACT_APP_SERVER_FILE}/${_info.product_cover}`; 

			setInfo(res.data.info);

			setContents(res.data.info.contents);
			

		})();
	}, []);

	

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
		
		const formattedTime2 = `${(hours < 10?"0":"")}${hours}:${minutes}`;

		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}.${month}.${day}`;
		
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			time2: formattedTime2,
			year: year,
			month: month,
			day: day,
		};
	};

	const handleBack = () => {
		navigate('/community');
	}


	// const renderCommentWrite = ({comments}: any) => {

		

	// 	const handleCommentSaveRequest = async () => {
	// 		const _commentContents = commentContents;

	// 		setCommentContents("");

	// 		if (initData.token_info.permission_group === "guest") {
				
		
	// 			modal({
	// 				title: "로그인", 
	// 				contents: <SigninForm modalSw={true} />,
	// 				buttons: []
	// 			});	
		
	// 			return toast ({
	// 				type: 'warning', 
	// 				contents: '로그인이 필요해요'
	// 			});
	// 		}
			
	// 		let isEmpty = fieldEmptyCheck(_commentContents);
			
	// 		if (isEmpty === "HasEmpty") {
	// 			return toast ({
	// 				type: 'warning', 
	// 				contents: '내용을 입력해 주세요.'
	// 			});
	// 		}

	// 		setCommentContents("");
		
	// 		const res: any = await requestAPI ('POST', `v1/comment/community/${id}`, {
	// 			commentContents: _commentContents,
	// 		});

	// 		console.log("rrrr ", res);
				
	// 		setComments(res.data.commentList);	
	// 	};

	// 	const fieldEmptyCheck = (text : string) => {
	// 		//공백이 있으면 true
			
	// 		const regex = /^\s*$/;
	
	// 		// console.log(text === '');
	// 		// console.log(text === null);
	// 		// console.log(text === undefined);
	// 		// console.log();
	
	// 		if (text === '' || text === null || text === undefined || regex.test(text)) {
	// 		  return "HasEmpty";     
	// 		}
			
	// 		return 'NoEmpty';
	// 	}

	// 	return (
	// 	  <div id="comments" className="listingSection__wrap">
	// 		{/* HEADING */}
			
	
	// 		{/* Content */}
	// 		<div className="space-y-5">
	// 			{/* <FiveStartIconForRate iconClass="w-6 h-6" className="space-x-0.5" /> */}
	// 			<div className="relative">
	// 				<Input
	// 					value={commentContents}
	// 					onChange={e => setCommentContents(e.target.value)}
	// 					fontClass=""
	// 					sizeClass="h-16 px-4 py-3"
	// 					rounded="rounded-3xl"
	// 					placeholder="질문 또는 후기를 남겨주세요..."
	// 				/>
	// 				<ButtonCircle
	// 					onClick={() => handleCommentSaveRequest()}
	// 					className="absolute right-2 top-1/2 transform -translate-y-1/2"
	// 					size=" w-12 h-12 "
	// 				>
	// 					<ArrowRightIcon className="w-5 h-5" />
	// 				</ButtonCircle>
	// 			  </div>
	// 		</div>
	
	// 		{/* comment */}
	// 		<div className="divide-y divide-neutral-100 dark:divide-neutral-800">
	// 			{
	// 				(comments.length > 0)
	// 				?
	// 					comments.map((item: any, idx: number) => (

	// 						<CommentListing 
	// 							className={"py-8"}
	// 							data={{
	// 								_id: item._id,
	// 								user_id: item.user_id,
	// 								self_id: initData.token_info.user_id,
	// 								name: item.user_name,
	// 								avatar: item.user_profileUrl,
	// 								date: formatKoreanDate(item.createdAt).date,
	// 								comment: item.comment,
	// 								starPoint: 3
	// 							}}
	// 							hasListingTitle={false}
	// 						/>
	// 					))
	// 				:
	// 					<div>아직 코멘트가 없어요</div>
	// 			}
				
	// 		  {/* <div className="pt-8">
	// 			<ButtonSecondary>View more 20 reviews</ButtonSecondary>
	// 		  </div> */}
	// 		</div>
	// 	  </div>
	// 	);
	// };
	
	
	const _createdAt = formatKoreanDate(info.createdAt);
	
	const handleModify = () => {
		navigate(`/community-post/${id}`);
	};

	const handleDelete = async () => {
		
		const res: any = await requestAPI ('DELETE', `v1/community/${id}`, {});
		console.log("res ", res)
		if (res.code === 1000) {

			navigate('/community');
		}
	};

	console.log("info ", info)

	if(Object.keys(info).length === 0) return (<></>);
	

	return (
	<>
		<div className={`container relative nc-SectionLatestPosts overflow-y ${className} w-screen md:w-[768px] h-full bg-white !p-0`}>
		
			<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
				<div className="container flex items-center justify-between sm:w-[768px] !p-0">
					<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
						
						<button
							className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
							onClick={()=> handleBack()}
						>
							<ArrowSmallLeftIcon className="w-6 h-6" />
						</button>
						{/* <LikeSaveBtns /> */}
						<span
							className="text-xl"
						>
							뒤로
						</span>
					</div>
					<div className="pr-5">
					
						{info.user_id === initData.userInfo._id
						?
							<div className="flex !space-x-2">
								<ButtonPrimary
									className="!m-0 !pt-1 !pb-1 !pl-4 !pr-4" 
									onClick={() => handleDelete()}
								>
									삭제
								</ButtonPrimary>
								<ButtonPrimary
									className="!m-0 !pt-1 !pb-1 !pl-4 !pr-4" 
									onClick={() => handleModify()}
								>
									수정
								</ButtonPrimary>
							</div>
						:
							<></>
						}
					</div>
				</div>
			</div>

			<div className="flex flex-col lg:flex-row">
				<div className="w-screen pl-[1rem] pr-[1rem] mb-[10rem] space-y-5">
					
					<div className="flex">
						<h2 
							className={`text-3xl md:text-4xl font-semibold mt-0 text-[1.4rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							{info.title}
						</h2>
					</div>

					<div
						className={`nc-CategoryBadgeList flex items-center flex-wrap space-x-2`}
						data-nc-id="CategoryBadgeList"
					>
						<PostCardMeta
							meta={{
								date: `${_createdAt.date} ${_createdAt.time2}`,
								author: {
									href: "/home",
									avatar: info.profileUrl,
									displayName: info.user_displayName,
								},
							}}
						/>
						<CommunityBadge
							type={info.type}
						/>
					</div>

					<div 
						className="text-neutral-6000 dark:text-neutral-300 mt-5 text-[1.0rem]"
						style={{fontWeight: "500", color:"#282f33"}}
					>
						<div
							dangerouslySetInnerHTML={{ __html: contents }}
						/>
						{info.type === "hotspot"
						?
							<></>
						:
							<>
								<div className="h-[20px]" />
								<ReservationCard data={info} />
								<div className="h-[20px]" />
							</>
						}	
					</div>

					<div className="mt-10">
						{/* {renderCommentWrite({comments})} */}
						<CommunityComments />
					</div>
					
				</div>
				
			</div>
			
		</div>
	</>
	);
};

export default CommunityView;
